import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface AnonymousUser {
  userId: string
}

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '',
  }),
  endpoints: (builder) => ({
    addAnonymousUser: builder.mutation({
      query: (payload: AnonymousUser) => ({
        url: `https://add-anonymous-user.gyore-soma.workers.dev`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const { useAddAnonymousUserMutation } = usersApi
